import { deserializeContacts } from './serializer';
import { ContactCardAttrs, ContactType } from './types';

export const convertContactCardToMarkdown = ({
  company,
  description,
  jobTitle,
  name,
  initialName,
  serializedContacts,
}: Pick<
  ContactCardAttrs,
  | 'company'
  | 'description'
  | 'jobTitle'
  | 'name'
  | 'initialName'
  | 'serializedContacts'
>) => {
  let markdown = '';

  const contactIcons: Record<ContactType, string> = {
    email: '📧',
    phone: '📱',
    website: '🌐',
    linkedin: '💼',
    twitter: '𝕏',
    facebook: '👥',
    calendar: '📅',
  };

  const _name = name || initialName;

  const jobInfo = [jobTitle, company].filter(Boolean).join(' • ');

  const contacts = deserializeContacts(serializedContacts);
  contacts.sort((a, b) => a.order - b.order);

  if (_name) {
    markdown += `**${_name}**${jobInfo ? ` (${jobInfo})` : ''}\n\n`;
  }

  if (description) {
    markdown += `${description}\n\n`;
  }

  contacts.forEach((contact) => {
    const icon = contactIcons[contact.type] || '';

    // Format the link based on contact type
    let link = '';
    switch (contact.type) {
      case 'email':
        link = `[${contact.value}](mailto:${contact.value})`;
        break;
      case 'phone':
        link = `[${contact.value}](tel:${contact.value.replace(/\s+/g, '')})`;
        break;
      default:
        link = `[${contact.label || contact.value}](${contact.value})`;
        break;
    }

    markdown += `* ${icon} ${link}\n`;
  });

  return markdown;
};
